export default __webpack_public_path__ + "static/media/girlscriptgoa.f75dfb3e.md";